<div class="div-rectangle-container" [ngStyle]="{'padding-bottom': (percentage + '%')}">
  <div class="div-rectangle-body">
    <ng-content class="cursor-pointer"></ng-content>
  </div>
</div>
